if (!customElements.get('deferred-iframe')) {
  class DeferredIframe extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      const videoTextContainer = this.querySelector('[data-video-text-container]');
      if (!videoTextContainer) return;

      videoTextContainer.addEventListener('click', this.loadContent.bind(this))
    }



    loadContent() {

      if (!this.getAttribute('loaded')) {
      
      const videoContainer = this.querySelector('[data-video-element]');

      videoContainer.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);

      }
    }

  }

  customElements.define('deferred-iframe', DeferredIframe)
}